import { useQueryState } from "nuqs";

import { useEffectOnce } from "shared/lib/hooks";

import { WIDGETS } from "@/constants/widgets";
import { WIDGETS_SEARCH_QUERY_PARAM_NAMES } from "@/components/shared/widgets/constants";

export const useSalesFloorsSearchQueryParams = () => {
  const [, setWidgetType] = useQueryState(
    WIDGETS_SEARCH_QUERY_PARAM_NAMES.WIDGET_TYPE
  );

  useEffectOnce(() => {
    void setWidgetType(WIDGETS.SALES_FLOORS);

    return () => {
      void setWidgetType(null);
    };
  });
};
